import { Box, List } from "@chakra-ui/react";
import { getFragmentData, gql } from "__generated__/gql";
import CreateButton from "components/Shared/CreateButton";
import EmptyPlaceholder from "components/Shared/EmptyPlaceholder";
import LoadingSpinner from "components/Shared/PageLoadingSpinner";
import { useState } from "react";
import { useBrandQuery } from "utils/apollo/hooks/brand";
import SkuOrderingPlatformCreate from "./Create";
import SkuOrderingPlatformItem from "./Item";

const fragment = gql(/* GraphQL */ `
  fragment SkuDetailsCustomersTabSku on Sku {
    id
    skuBrandOrderingPlatformsList(orderBy: CREATED_AT_ASC) {
      id
      ...SkuPanelSkuBrandOrderingPlatform
    }
  }
`);

const query = gql(/* GraphQL */ `
  query SkuDetailsCustomersTab($skuId: UUID!) {
    sku(id: $skuId) {
      id
      ...SkuDetailsCustomersTabSku
    }
  }
`);

type Props = {
  skuId: UUID | null | undefined;
};

export default function CustomersTab({ skuId }: Props) {
  const [isAdding, setIsAdding] = useState(false);

  const { data, loading: isLoading } = useBrandQuery(query, {
    skip: !skuId,
    variables: skuId ? { skuId } : undefined,
    fetchPolicy: "cache-and-network",
  });

  const sku = getFragmentData(fragment, data?.sku);
  const sbops = sku?.skuBrandOrderingPlatformsList || [];

  return (
    <>
      {(!!sbops.length || isAdding) && (
        <List>
          {sbops.map((sbop) => (
            <SkuOrderingPlatformItem
              key={sbop.id}
              skuBrandOrderingPlatform={sbop}
            />
          ))}

          {isAdding && (
            <SkuOrderingPlatformCreate
              skuId={skuId}
              onCancel={() => setIsAdding(false)}
              onCompleted={() => setIsAdding(false)}
            />
          )}
        </List>
      )}

      {isLoading && <LoadingSpinner m={6} />}

      {!isLoading && sbops.length === 0 && !isAdding && (
        <EmptyPlaceholder
          as={Box}
          opacity={0.5}
          px={6}
          my={4}
          textAlign="center"
        >
          No customers added.
        </EmptyPlaceholder>
      )}

      {!isLoading && !isAdding && (
        <Box textAlign="center" px={6} my={4}>
          <CreateButton size="sm" onClick={() => setIsAdding(true)}>
            Add New Customer
          </CreateButton>
        </Box>
      )}
    </>
  );
}
